<template>
    <div class="fixed top-2 w-full z-50 flex justify-center px-4">
        <div class="fixed max-w-7xl w-full z-40 px-4">
            <div class="w-full flex space-x-1.5 p-3 py-2.5 my-2 text-sm rounded-md items-center" :class="{
                    'bg-red-100 text-red-500 border border-red-300' : type == 'error',
                    'bg-green-100 text-green-600 border border-green-300' : type == 'success',
                    'bg-yellow-100 text-yellow-700 border border-yellow-400' : type == 'warning'
                }">
                <div v-if="type == 'success'">
                    <svg class="w-6 h-6 text-green-500" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg>
                </div>
                <div v-if="type == 'error'">
                    <svg class="w-6 h-6 text-red-500" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path></svg>
                </div>
                <div v-if="type == 'warning'">
                    <svg class="w-6 h-6 text-yellow-700" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path></svg>
                </div>
                <div class="flex-1 font-medium">
                    {{ message }}
                </div>
                <div class="" @click="$emit('clicked')">
                    <div class="cursor-pointer rounded p-1.5" :class="{
                            'text-green-500 bg-green-100 hover:bg-green-200': type == 'success',
                            'text-red-500 bg-red-100 hover:bg-red-200': type == 'error',
                            'text-yellow-700 bg-yellow-100 hover:bg-yellow-200': type == 'warning'
                        }">
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    props: [ 'message', 'type' ],
    emits: [ 'clicked' ],
}
</script>
